import styled, { css } from 'styled-components';

import { COLORS } from '@theme/colors';
import { media } from '@theme/media';

import FacebookSVG from '../../assets/images/icon-facebook.svg';
import InstagramSVG from '../../assets/images/icon-instagram.svg';

export const Container = styled.footer`
  padding: 0 24px;
  position: relative;
  width: 100%;

  ${media.tablet} {
    padding: 0 34px;
  }
`;

export const Content = styled.div`
  box-sizing: border-box;
  color: ${COLORS.BLACK};
  border-top: 1px solid ${COLORS.ALTO};
  padding: 34px 0 40px;

  ${media.tablet} {
    padding: 34px 0 17px;
  }
`;

export const Links = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${media.desktop} {
    flex-direction: row;
  }
`;

export const LinksList = styled.ul`
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 0;

  ${media.mobile} {
    flex-direction: row;
    align-items: center;
    margin-bottom: 4px;
  }

  ${media.desktop} {
    margin-bottom: 0;
  }
`;

export const LinkItem = styled.li`
  padding: 10px;

  ${media.mobile} {
    padding: 0;
  }
`;

export const LinkContent = styled.span`
  padding-bottom: 1px;
`;

export const MainLogo = styled(LinkContent)`
  text-transform: uppercase;
`;

export const linkStyles = css`
  text-decoration: none;
  padding: 4px 12px 4px 0;
  border: none;
  background: none;

  &:hover {
    ${LinkContent} {
      border-bottom: 1px solid ${COLORS.BLACK};
    }
  }
`;

export const Link = styled.a`
  ${linkStyles};
`;

export const Button = styled.button.attrs({ type: 'button' })`
  ${linkStyles};
`;

export const SocialList = styled.ul`
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0;
`;

export const SocialItem = styled.li`
  width: 24px;
  height: 26px;

  &:not(:first-of-type) {
    margin-left: 20px;
    ${media.mobile} {
      margin-left: 0;
    }
  }
`;

export const SocialLink = styled.a`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  ${media.mobile} {
    justify-content: center;
  }
`;

const iconStyles = css`
  width: 12px;
  height: 12px;

  ${media.mobile} {
    width: 9px;
    height: 9px;
  }
`;

export const FacebookIcon = styled(FacebookSVG)`
  ${iconStyles};
`;

export const InstagramIcon = styled(InstagramSVG)`
  ${iconStyles};
`;
